﻿import {attributes} from "./overview-filter-constants";

const findBadges = (name) => document.querySelectorAll(`[${attributes.filterBadge}][${attributes.filterName}=${name}]`);

const showBadges = (name, content) => {
	const badges = findBadges(name);
	badges.forEach((badge) => {
		if (!badge.dataset.badgeContentStatic)
			badge.innerHTML = content;

		badge.classList.remove("tw-hidden");
	});
}
const hideBadges = (name) => {
	const badges = findBadges(name);
	badges.forEach((badge) => {
		if (!badge.dataset.badgeContentStatic)
			badge.innerHTML = "";

		badge.classList.add("tw-hidden");
	});
}

export const setBadges = (name, value) => {
	if (value) {
		showBadges(name, value);
	} else {
		hideBadges(name);
	}
}
